export default "__VITE_ASSET__BGUfF$II__"